import { adapter } from '@seek/tealium-adapter';

import { allTrackingState, type InitialAppState } from './analytics';

const tealium = adapter();

interface TrackLinkProps {
  eventName: string;
  currentPageSection: string;
  isExitLink?: boolean;
}

export const createAccountAnalytics = (initialState: InitialAppState) => {
  const trackAccountLink = (props: TrackLinkProps) => {
    const { eventName } = props;
    const trackingfields = {
      ...initialState,
      ...allTrackingState(),
      ...props,
      currentPage: 'account settings',
    };
    tealium.link(eventName, trackingfields);
  };

  return {
    trackAccountLink,
  };
};

export type AccountAnalytics = ReturnType<typeof createAccountAnalytics>;
